<template>
	<div>
		<el-dialog title="编辑选项" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
			<div class="cascader-edit-box-wrap">
				<ul class="cascader-edit-box-wrap-ul">
					<li class="cascader-edit-box-wrap-ul-li">
						<div class="cascader-col-title">一级选项</div>
						<el-input size="small" class="wj-input" v-model="question.optionPlaceholder1" placeholder="请选择"
							@focus="e => inputFocusOne(e, { children: [], value: '' })"></el-input>
						<div v-for="item in question.optionList" :key="item.id"
							:class="item.id == levelOneId ? 'wj-inputActive' : 'wj-input'">
							<el-input size="small" v-model="item.label" @focus="e => inputFocusOne(e, item)"></el-input>
							<i class="el-icon-remove wj-icon-remove" @click="delOptionListOne(item)"></i>
						</div>
						<div>
							<i class="el-icon-circle-plus-outline el-icon-common" @click="addOnelevelOption()">添加选项</i>
							<!-- <i class="el-icon-circle-plus-outline el-icon-common" @click="addOneOther">添加其他</i> -->
						</div>
					</li>
					<li class="cascader-edit-box-wrap-ul-li">
						<div class="cascader-col-title">二级选项</div>
						<el-input v-if="levelOneId != ''" size="small" class="wj-input"
							v-model="question.optionPlaceholder2" placeholder="请选择"
							@focus="e => inputFocusTwo(e, { children: [], id: '' })"></el-input>
						<div v-for="item in levelTwoOptionList" :key="item.id"
							:class="item.id == levelTwoId ? 'wj-inputActive' : 'wj-input'">
							<el-input size="small" v-model="item.label" @focus="e => inputFocusTwo(e, item)"></el-input>
							<i class="el-icon-remove wj-icon-remove " @click="delOptionListTwo(item)"></i>
						</div>
						<div v-if="levelOneId != ''">
							<i class="el-icon-circle-plus-outline el-icon-common" @click="addTwolevelOption()">添加选项</i>
							<!-- <i class="el-icon-circle-plus-outline el-icon-common">添加其他</i> -->
						</div>
					</li>
					<li class="cascader-edit-box-wrap-ul-li">
						<div class="cascader-col-title">三级选项</div>
						<el-input v-if="levelTwoId != '' && levelOneId != ''" size="small" class="wj-input"
							v-model="question.optionPlaceholder3" placeholder="请选择"
							@focus="e => inputFocusThree(e, { children: [], id: '' })"></el-input>
						<div v-for="item in levelThreeOptionList" :key="item.id"
							:class="item.id == levelThreeId ? 'wj-inputActive' : 'wj-input'">
							<el-input size="small" v-model="item.label" @focus="e => inputFocusThree(e, item)">
							</el-input>
							<i class="el-icon-remove wj-icon-remove" @click="delOptionListThree(item)"></i>
						</div>
						<div v-if="levelTwoId != '' && levelOneId != ''">
							<i class="el-icon-circle-plus-outline el-icon-common"
								@click="addThreelevelOption()">添加选项</i>
							<!-- <i class="el-icon-circle-plus-outline el-icon-common">添加其他</i> -->
						</div>
					</li>
					<li class="cascader-edit-box-wrap-ul-li">
						<div class="cascader-col-title">四级选项</div>
						<el-input v-if="levelThreeId != '' && levelTwoId != '' && levelOneId != ''" size="small"
							class="wj-input" v-model="question.optionPlaceholder4" placeholder="请选择"
							@focus="e => inputFocusFour(e, { children: [], id: '' })"></el-input>
						<div v-for="item in levelFourOptionList" :key="item.id"
							:class="item.id == levelFourId ? 'wj-inputActive' : 'wj-input'">
							<el-input size="small" v-model="item.label" @focus="e => inputFocusFour(e, item)">
							</el-input>
							<i class="el-icon-remove wj-icon-remove" @click="delOptionListFour(item)"></i>
						</div>
						<div v-if="levelThreeId != '' && levelTwoId != '' && levelOneId != ''">
							<i class="el-icon-circle-plus-outline el-icon-common" @click="addFourlevelOption()">添加选项</i>
							<!-- <i class="el-icon-circle-plus-outline el-icon-common">添加其他</i> -->
						</div>
					</li>
				</ul>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit">保 存</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		v1 as UUID
	} from 'uuid';
	export default {
		props: {
			question: {
				type: Object
			}
		},

		data() {
			return {
				dialogVisible: false,
				levelTwoOptionList: [],
				levelThreeOptionList: [],
				levelFourOptionList: [],
				levelOneId: '',
				levelTwoId: '',
				levelThreeId: '',
				levelFourId: ''
			};
		},
		methods: {
			submit() {
				this.question.optionList.forEach((item, index) => {
					if (item.children.length == 0) {
						delete item.children;
					} else {
						console.log(item.children);
						if (item.children) {
							item.children.forEach((item2, index2) => {
								console.log(item2);
								if (item2.children && item2.children.length == 0) {
									delete item2.children;
								} else {
									if (item2.children) {
										item2.children.forEach((item3, index3) => {
											if (item3.children && item3.children.length == 0) {
												delete item3.children;
											} else {
												if (item3.children) {
													item3.children.forEach((item4, index4) => {
														if (item4.children && item4
															.children.length == 0) {
															delete item4.children;
														}
													});
												}
											}
										});
									}
								}
							});
						}
					}
				});
				console.log(this.question.optionList);
				this.dialogVisible = false;
			},
			addOneOther() {},
			// 删除第一组
			delOptionListOne(value) {
				this.levelOneId = value.id;
				if (this.question.optionList.length == 1) {
					this.$message.warning('该选项不可删除');
					return false;
				}
				this.question.optionList.forEach((item, index) => {
					if (value.id == item.id) {
						this.question.optionList.splice(index, 1);
						this.levelTwoOptionList = [];
						this.levelThreeOptionList = [];
						this.levelFourOptionList = [];
						this.levelOneId = '';
					}
				});
			},
			// 删除第二组
			delOptionListTwo(value) {
				this.levelTwoId = value.id;
				this.question.optionList.forEach((item, index) => {
					if (this.levelOneId == item.id) {
						item.children.forEach((item2, index2) => {
							if (this.levelTwoId == item2.id) {
								item.children.splice(index2, 1);
								this.levelThreeOptionList = [];
								this.levelFourOptionList = [];
								this.levelTwoId = '';
							}
						});
					}
				});
			},
			// 删除第三组
			delOptionListThree(value) {
				this.levelThreeId = value.id;
				console.log(this.levelThreeId);
				this.question.optionList.forEach((item, index) => {
					if (this.levelOneId == item.id) {
						item.children.forEach((item2, index2) => {
							if (this.levelTwoId == item2.id) {
								item2.children.forEach((item3, index3) => {
									if (this.levelThreeId == item3.id) {
										item2.children.splice(index3, 1);
										this.levelFourOptionList = [];
										this.levelThreeId = '';
									}
								});
							}
						});
					}
				});
			},
			// 删除第四组
			delOptionListFour(value) {
				this.levelFourId = value.id;
				this.question.optionList.forEach((item, index) => {
					if (this.levelOneId == item.id) {
						item.children.forEach((item2, index2) => {
							if (this.levelTwoId == item2.id) {
								item2.children.forEach((item3, index3) => {
									if (this.levelThreeId == item3.id) {
										item3.children.forEach((item4, index4) => {
											if (this.levelFourId == item4.id) {
												item3.children.splice(index4, 1);
												this.levelFourOptionList = item3.children;
												this.levelFourId = '';
											}
										});
									}
								});
							}
						});
					}
				});
			},
			addOnelevelOption() {
				let tempNew = {
					id: UUID(),
					value: '选项' + Number(this.question.optionList.length + 1),
					label: '选项' + Number(this.question.optionList.length + 1),
					type: 1,
					children: []
				};
				this.question.optionList.push(tempNew);
			},
			addTwolevelOption() {

				console.log(this.question.optionList);
				this.question.optionList.forEach(item => {
					if (this.levelOneId == item.id) {
						console.log(item)
						let tempNew = {
							id: UUID(),
							value: item.value + '-' + Number(this.levelTwoOptionList.length + 1),
							label: item.value + '-' + Number(this.levelTwoOptionList.length + 1),
							type: 1,
							children: []
						};
						item.children.push(tempNew);
						this.levelTwoOptionList = item.children;
					}
				});
			},
			addThreelevelOption() {
				this.question.optionList.forEach(item => {
					if (this.levelOneId == item.id) {
						item.children.forEach(item2 => {
							if (this.levelTwoId == item2.id) {
								let tempNew = {
									id: UUID(),
									value: item2.value + '-' + Number(this.levelThreeOptionList.length + 1),
									label: item2.value + '-' + Number(this.levelThreeOptionList.length + 1),
									type: 1,
									children: []
								};
								item2.children.push(tempNew);
								this.levelThreeOptionList = item2.children;
							}
						});
					}
				});
			},
			addFourlevelOption() {
				this.question.optionList.forEach(item => {
					if (this.levelOneId == item.id) {
						item.children.forEach(item2 => {
							if (this.levelTwoId == item2.id) {
								item2.children.forEach(item3 => {
									if (this.levelThreeId == item3.id) {
										let tempNew = {
											id: UUID(),
											value: item3.value + '-' + Number(this.levelFourOptionList.length + 1),
											label: item3.value + '-' + Number(this.levelFourOptionList.length + 1),
											type: 1,
											children: []
										};
										item3.children.push(tempNew);
										// this.levelFourOptionList.push(tempNew);
										this.levelFourOptionList= item3.children;
									}
								});
							}
						});
					}
				});
			},
			inputFocusOne(e, value) {
				console.log(value);
				value.value = value.label
				this.levelOneId = value.id;
				if (this.levelOneId == '') {
					this.levelTwoId = '';
					this.levelThreeId = '';
					this.levelFourId = '';
				}
				if (!value.children) {
					value.children = [];
				}
				if (value.children.length == 0) {
					this.levelTwoOptionList = [];
					this.levelThreeOptionList = [];
					this.levelFourOptionList = [];
				} else {
					this.levelTwoOptionList = value.children;
				}
			},
			inputFocusTwo(e, value) {
				this.levelTwoId = value.id;
				value.value = value.label
				if (this.levelTwoId == '') {
					this.levelThreeId = '';
					this.levelFourId = '';
				}
				if (!value.children) {
					value.children = [];
				}
				if (value.children.length == 0) {
					this.levelThreeOptionList = [];
					this.levelFourOptionList = [];
				} else {
					this.levelThreeOptionList = value.children;
				}
			},
			inputFocusThree(e, value) {
				this.levelThreeId = value.id;
				value.value = value.label
				if (this.levelThreeId == '') {
					this.levelFourId = '';
				}
				if (!value.children) {
					value.children = [];
				}
				if (value.children.length == 0) {
					this.levelFourOptionList = [];
				} else {
					this.levelFourOptionList = value.children;
				}
			},
			inputFocusFour(e, value) {
				this.levelFourId = value.id;
				value.value = value.label
			}
		}
	};
</script>
<style lang="scss" scoped>
	.cascader-edit-box-wrap {
		height: 488px;

		.cascader-edit-box-wrap-ul {
			display: flex;
			height: 100%;
			padding: 20 0px;
			background-color: #f9f9f9;
			border-top: 1px solid #dde5ed;

			.cascader-edit-box-wrap-ul-li {
				flex: 1;
				height: 100%;
				padding: 0 0 0 10px;
				overflow-y: auto;

				.cascader-col-title {
					padding: 24px 0 12px;
					line-height: 1;
					text-align: left;
					font-size: 14px;
					color: #707070;
				}

				.wj-input {
					width: 182px;
					margin-bottom: 10px;

					.wj-icon-remove {
						display: none;
					}
				}

				.wj-inputActive {
					width: 182px;
					margin-bottom: 10px;
					border: 1px solid #2672ff;
					position: relative;

					.wj-icon-remove {
						display: block;
						position: absolute;
						right: -5px;
						top: -5px;
						cursor: pointer;
						color: red;
					}
				}
			}

			.cascader-edit-box-wrap-ul-li:not(:last-child) {
				border-right: 1px solid #dde5ed;
			}
		}
	}

	.el-icon-common {
		margin-left: 10px;
		color: cornflowerblue;
		cursor: pointer;
	}

	.el-icon-common:first-child {
		margin-left: 0px;
	}
</style>
